import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQuery } from './fetch-base-query';
import { aiDashboardSlice } from '../reducers/ai-dashboard';

export const aiDashboardApi = createApi({
  reducerPath: 'aiDashboardApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    aiDashboard: builder.query<any, number>({
      query: (aiId) => ({
        url: `/ai-dashboard/${aiId}`,
        method: 'GET',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(aiDashboardSlice.actions.setAiDashboard(data));
      },
    }),

    aiDashboardControls: builder.query<any, number>({
      query: (aiId) => ({
        url: `/aiAllTagManagement/${aiId}`,
        method: 'GET',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(aiDashboardSlice.actions.setAiDashboardControls(data));
      },
    }),
  }),
});
